// extracted by mini-css-extract-plugin
export default {"pageContainer_txdis":"TexasDisclosure_pageContainer_txdis__g5X-S","hero_image_txdis":"TexasDisclosure_hero_image_txdis__EfUQx","heading_txdis":"TexasDisclosure_heading_txdis__c8Rb7"};